<template>
    <print-container>
        <div class="text-center title mt-7 mb-0">{{title}}</div>
        <div class="text-center subtitle-1 px-3 pb-6 my-0 ">{{subtitle}}</div>
        <tabelle :saison="saison" :hide-legend="true" :dense="true" :is-print="true"
                 :class="[{'mb-8': $vuetify.breakpoint.smAndDown},
                     {'mb-4': $vuetify.breakpoint.mdAndUp}]">
        </tabelle>
    </print-container>
</template>

<script>
    import Tabelle from "../tabelle";
    import PrintContainer from "./printContainer";

    export default {
        components: {
            PrintContainer,
            Tabelle},
        name: "print-tabellen",
        computed: {
            saison(){return this.$store.state.local.printContainer.saison},
            title(){
                return this.$store.state.realtime
                        .landesverbaende[this.saison.lvId].ligen[this.saison.ligaId].nameFull +
                    ' ' + this.saison.sportJahr.replace('_', '/');
            },
            subtitle(){
                return this.$store.state.realtime
                        .landesverbaende[this.saison.lvId].name;
            },
        },
    }
</script>

<style scoped>
</style>